/**
 * Todo module enum-ish constants.
 *
 * The module is deliberately tiny — it has no display enums of its own (a todo
 * is done or not; that is a boolean). All this file carries is the sync table
 * set, disjoint from groceries' `SYNC_TABLES` and agenda's `AGENDA_SYNC_TABLES`,
 * so the module keeps its own independent sync channel.
 */
export const TODO_SYNC_TABLES = ['todos'];
export function isTodoSyncTable(value) {
    return TODO_SYNC_TABLES.includes(value);
}
//# sourceMappingURL=enums.js.map